import { useState } from 'react';
import { Icon } from '../shared';
import { Button, Input } from '../ui';

interface AddToPlanModalProps {
   onClose: () => void;
   onConfirm: (date: string, meal: string, options: { quantity: number; note: string }) => void;
   recipeName?: string;
   recipeCalories?: number;
}

const MEAL_OPTIONS = ['早餐', '午餐', '晚餐', '加餐'];

export const AddToPlanModal = ({ onClose, onConfirm, recipeName, recipeCalories }: AddToPlanModalProps) => {
   const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
   const [meal, setMeal] = useState('晚餐');
   const [quantity, setQuantity] = useState(1);
   const [note, setNote] = useState('');

   const totalCalories = recipeCalories ? recipeCalories * quantity : 0;

   const handleConfirm = () => {
      onConfirm(date, meal, { quantity, note });
   };

   return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
         <div className="bg-parchment dark:bg-parchment-dark w-full max-w-sm rounded-xl border-4 border-wood-dark shadow-pixel p-4 jagged-corners">
            <h3 className="text-xl font-black text-wood-darker dark:text-[#deb887] mb-4">加入计划</h3>

            {recipeName && (
               <div className="mb-4 p-3 bg-wood-light/10 dark:bg-wood-dark/20 rounded-lg">
                  <p className="font-bold text-wood-darker">{recipeName}</p>
                  {recipeCalories && (
                     <p className="text-sm text-wood-medium">
                        基础热量: {recipeCalories} kcal
                     </p>
                  )}
               </div>
            )}

            <div className="flex flex-col gap-4 mb-6">
               <div>
                  <label className="text-xs font-bold text-wood-medium block mb-1">日期</label>
                  <Input
                     type="date"
                     id="plan-date"
                     name="date"
                     value={date}
                     onChange={e => setDate(e.target.value)}
                  />
               </div>
               <div>
                  <label className="text-xs font-bold text-wood-medium block mb-1">时段</label>
                  <select
                     id="plan-meal"
                     name="meal"
                     value={meal}
                     onChange={e => setMeal(e.target.value)}
                     className="w-full bg-[#fff8e1] dark:bg-[#3e2723] border-2 border-[#ffe0b2] rounded p-2 text-wood-darker font-bold"
                  >
                     {MEAL_OPTIONS.map(option => (
                        <option key={option} value={option}>{option}</option>
                     ))}
                  </select>
               </div>

               {/* 份量选择 */}
               <div>
                  <label className="text-xs font-bold text-wood-medium block mb-1">份量</label>
                  <div className="flex items-center gap-3">
                     <button
                        onClick={() => setQuantity(Math.max(0.5, quantity - 0.5))}
                        className="p-2 bg-wood-light/20 rounded hover:bg-wood-light/30 transition-colors"
                     >
                        <Icon name="remove" className="text-sm" />
                     </button>
                     <span className="w-16 text-center font-bold text-lg">{quantity}x</span>
                     <button
                        onClick={() => setQuantity(quantity + 0.5)}
                        className="p-2 bg-wood-light/20 rounded hover:bg-wood-light/30 transition-colors"
                     >
                        <Icon name="add" className="text-sm" />
                     </button>
                  </div>
                  {totalCalories > 0 && (
                     <p className="text-xs text-wood-medium mt-1">
                        调整后热量: {totalCalories} kcal
                     </p>
                  )}
               </div>

               {/* 备注 */}
               <div>
                  <label className="text-xs font-bold text-wood-medium block mb-1">备注（可选）</label>
                  <textarea
                     value={note}
                     onChange={e => setNote(e.target.value)}
                     placeholder="添加备注..."
                     className="w-full bg-[#fff8e1] dark:bg-[#3e2723] border-2 border-[#ffe0b2] rounded p-2 text-wood-darker text-sm min-h-[60px] resize-none"
                  />
               </div>
            </div>

            <div className="flex gap-3">
               <Button variant="neutral" className="flex-1" onClick={onClose}>取消</Button>
               <Button variant="success" className="flex-1" onClick={handleConfirm}>确认加入</Button>
            </div>
         </div>
      </div>
   );
};